// class SimpleContactForm extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {

//     this.container = this.querySelector(".simple-contact-form")
//     this.currentPage = 1
//     this.form = this.querySelector("form")

//     this.buttons = this.querySelectorAll("button")

//     this.buttons.forEach( b => {
//       b.addEventListener('click', this.handleButtonClick.bind(this))
//     })

//     this.triggers = document.querySelectorAll(`[href='#${ this.form.id }']`)

//     if(this.triggers.length > 0) {
//       this.setupModals()
//     }

//   }

//   setupModals() {
//     this.close = this.querySelector(".modal-contact-form__close")
    
//     this.triggers.forEach( trigger => {
//       trigger.addEventListener("click", (e) => {
//         e.preventDefault()

//         if(trigger.dataset.title && this.querySelector('.simle-contact-form__form-text').querySelector("span[data-var]") != null ) {
//           this.querySelector('.simle-contact-form__form-text').querySelector("span[data-var]").innerHTMl = trigger.dataset.title
//         } else if(this.querySelector('.simle-contact-form__form-text').querySelector("span[data-var]") != null){
//           this.querySelector('.simle-contact-form__form-text').querySelector("span[data-var]").innerHTMl = this.querySelector('.simle-contact-form__form-text').dataset.var || 'bike'
//         }
        
//         this.querySelector(".modal-contact-form").style.display = 'flex'
//         document.body.style.overflow = 'clip';
//          document.body.classList.add('height__100vh__fixed');
//       })
//     })

//     this.close.addEventListener("click", (e) => {
//       e.preventDefault()
//       this.querySelector(".modal-contact-form").style.display = 'none'
//       document.body.style.removeProperty('overflow');
//       document.body.classList.remove('height__100vh__fixed');
//     })
//   }
  
//   checkRequiredFields() {
//     const requiredFields = this.querySelectorAll("[required]")
//     let valid = true

//     requiredFields.forEach( f => {
//       if( f.value == '') {
//         valid = false
//         f.parentElement.querySelector(".error").style.display = 'block'
//       } else {
//         f.parentElement.querySelector(".error").style.removeProperty("display")
//       }
//     })

//     return valid
//   }

//   handleButtonClick(event) {
//     if (event) event.preventDefault()

//     const target = event.target.tagName == "BUTTON" ? event.target : event.target.closest("button")

//     if(target.dataset.type == 'close'){
//       target.closest("form").querySelector(".modal-contact-form").style.display = 'none'
//       document.body.style.removeProperty('overflow')
//     }
//     else if(target.dataset.type == 'continue' ) {
//       this.handleChangePage()
//     } else {
//       this.handleSubmit()
//     }
    
//   }

//   handleChangePage() {
//     // check if required fields have values
//     const pageIsValid = this.checkRequiredFields()
    
//     // advance page number
//     if(pageIsValid) {
//       this.currentPage = parseInt(this.currentPage) + 1
//       this.container.setAttribute('data-form-page', this.currentPage)
//     }
    
// }
  
//   handleSubmit(event) {
//     var callback = function () {
//       if (typeof(url) != 'undefined') {
//         window.location = url;
//       }
//     };
//     gtag('event', 'conversion', {
//         'send_to': 'AW-10853722849/_mJQCLWNqakDEOHVurco',
//         'event_callback': callback
//     });

//     this.form.submit()
//   }
// }

// customElements.define('simple-contact-form', SimpleContactForm)




class SimpleContactForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector(".simple-contact-form");
    this.currentPage = 1;
    this.form = this.querySelector("form");
    this.buttons = this.querySelectorAll("button");

    this.buttons.forEach((b) => {
      b.addEventListener("click", this.handleButtonClick.bind(this));
    });

    this.triggers = document.querySelectorAll(`[href='#${this.form.id}']`);

    if (this.triggers.length > 0) {
      this.setupModals();
    }
  }

  setupModals() {
    this.close = this.querySelector(".modal-contact-form__close");

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        const varTextEl = this.querySelector(
          ".simle-contact-form__form-text span[data-var]"
        );

        if (trigger.dataset.title && varTextEl) {
          varTextEl.innerHTML = trigger.dataset.title;
        } else if (varTextEl) {
          varTextEl.innerHTML =
            this.querySelector(".simle-contact-form__form-text").dataset.var ||
            "bike";
        }

        this.querySelector(".modal-contact-form").style.display = "flex";
        document.body.style.overflow = "clip";
        document.body.classList.add("height__100vh__fixed");
      });
    });

    this.close.addEventListener("click", (e) => {
      e.preventDefault();
      this.querySelector(".modal-contact-form").style.display = "none";
      document.body.style.removeProperty("overflow");
      document.body.classList.remove("height__100vh__fixed");
    });
  }

  checkRequiredFields() {
    const requiredFields = this.querySelectorAll("[required]");
    let valid = true;

    requiredFields.forEach((f) => {
      if (f.value.trim() === "") {
        valid = false;
        f.parentElement.querySelector(".error").style.display = "block";
      } else {
        f.parentElement.querySelector(".error").style.removeProperty("display");
      }
    });

    return valid;
  }

  handleButtonClick(event) {
    if (event) event.preventDefault();

    const target =
      event.target.tagName === "BUTTON"
        ? event.target
        : event.target.closest("button");

    if (target.dataset.type === "close") {
      target
        .closest("form")
        .querySelector(".modal-contact-form").style.display = "none";
      document.body.style.removeProperty("overflow");
    } else if (target.dataset.type === "continue") {
      this.handleChangePage();
    } else {
      this.handleSubmit();
    }
  }

  handleChangePage() {
    const pageIsValid = this.checkRequiredFields();

    if (pageIsValid) {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.container.setAttribute("data-form-page", this.currentPage);
    }
  }

  handleSubmit(event) {
    const callback = function () {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };

    if (typeof gtag !== "undefined") {
      gtag("event", "conversion", {
        send_to: "AW-10853722849/_mJQCLWNqakDEOHVurco",
        event_callback: callback,
      });
    }

    // ✅ Use requestSubmit() to trigger native validation and Shopify processing
    this.form.requestSubmit();
  }
}

customElements.define("simple-contact-form", SimpleContactForm);
